export default "__VITE_ASSET__DQ$1myJY__"